import React from 'react';
import { Button as EcoButton } from "@bsw/react-nightingale";

export const Button = (props) => {
    return <EcoButton {...props} />;
}
